// extracted by mini-css-extract-plugin
module.exports = {"list":"RideList_list__LnO4x"};